"use client"

import type React from "react"
import { useEffect, useState } from "react"

/**
 * RootClientShell
 *
 * This component ensures that the app only renders its full UI
 * after the client has mounted. During SSR and the initial client
 * hydration pass, it renders a simple, stable shell so that
 * server and client markup match exactly.
 *
 * This is a defensive measure to eliminate React hydration errors
 * (#418 / #423) caused by unavoidable server/client differences
 * in deeply nested components (dates, localStorage-driven content, etc.).
 */
export function RootClientShell({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return (
      <div className="min-h-screen bg-background text-foreground flex items-center justify-center">
        <div className="text-center space-y-4">
          <p className="text-lg text-muted-foreground">Loading spots2surf...</p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}


